import { useCallback, useMemo } from 'react'
import { getIn, getNestedValuePath, createDeleteNestedValue, createSetNestedValue, useFormikContext } from '../Formik/forms'

import Button from '@mui/material/Button'
import { useOrbit } from 'providers/OrbitProvider'

export default function ForEachNestedValue({path, buttonText, newValue, component: Component, permitEdit}) {
  const { values, setFieldValue } = useFormikContext()
  const { store } = useOrbit()
  const setNestedValue = useMemo(() => createSetNestedValue({store, values, setFieldValue}), [store, values, setFieldValue])
  const deleteNestedValue = useMemo(() => createDeleteNestedValue({store, values, setFieldValue}), [store, values, setFieldValue])
  const valuesPath = useMemo(() => getNestedValuePath(store, values, setFieldValue, path), [store, values, setFieldValue, path])
  const nestedValues = useMemo(() => getIn(values, valuesPath) || [], [values, valuesPath])

  const handleAdd = useCallback(() => {
    setNestedValue(path, newValue())
  }, [setNestedValue, path, newValue])

  const handleRemove = useCallback((item) => {
    deleteNestedValue(path, item.__record)
  }, [deleteNestedValue, path])

  return (
    <>
      {nestedValues.map((item, index) => (
        !item._destroy && (
          <Component
            key={index}
            item={item}
            path={`${valuesPath}[${index}]`}
            onRemove={() => handleRemove(item)}
            permitEdit={permitEdit}
          />
        )
      ))}
      {permitEdit &&
        <Button onClick={handleAdd} sx={{mt: 2}}>{buttonText || 'Add'}</Button>
      }
    </>
  )
}
